module.exports = __webpack_public_path__ + "static/media/sf-test-12.c7a0bf96.mp3";